export function unwrapDefaultExport(moduleExport) {
  let current = moduleExport
  let depth = 0

  while (
    current &&
    typeof current === 'object' &&
    Object.prototype.hasOwnProperty.call(current, 'default') &&
    current.default &&
    current.default !== current &&
    depth < 5
  ) {
    current = current.default
    depth += 1
  }

  return current
}

export default function configureReactRailsContext(ReactRailsUJS, requireContext) {
  const reactRailsUJS = ReactRailsUJS

  reactRailsUJS.useContext(requireContext)

  const fallbackGetConstructor = reactRailsUJS.getConstructor

  reactRailsUJS.getConstructor = function getConstructorWithInterop(componentName) {
    try {
      const fallbackConstructor = fallbackGetConstructor(componentName)
      return unwrapDefaultExport(fallbackConstructor)
    } catch (error) {
      return undefined
    }
  }
}
